import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import PropTypes from 'prop-types';

const BP1225 = '@media (max-width: 1250px)';
const BP1 = '@media (max-width: 899px)';
const BP2 = '@media (max-width: 600px)';

const sx = {
  description: {
    margin: 'auto',
    fontFamily: 'boucherie-block',
    fontSize: '22px',
    color: '#D2D4C2',
    textAlign: 'center',
    lineHeight: '40px',
  },
  imageContainer: {
    margin: 'auto',
    cursor: 'pointer',
  },
};

const RulesGallery = ({ title, images, setFullscreenSource }) => {
  return (
    <>
      <Typography
        sx={sx.description}
        style={{
          color: '#D2D4C2',
          maxWidth: '610px',
          marginBottom: '10px',
        }}
      >
        {title}
      </Typography>
      <Grid
        container
        spacing={0}
        justifyContent="center"
        style={{
          gap: '12px',
          maxWidth: '728px',
          zIndex: 1,
          margin: 'auto',
          marginBottom: '8px',
        }}
        sx={sx.gridContainer}
      >
        {images.map((img, index) => (
          <Grid item xs={3.4} sm={2.1} md={2.2} key={index}>
            <Box>
              <Box
                sx={sx.imageContainer}
                onClick={() => setFullscreenSource(img)}
              >
                <img
                  src={img}
                  alt=""
                  style={{ width: '100%', borderRadius: '8px' }}
                />{' '}
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
RulesGallery.propTypes = {
  images: PropTypes.any.isRequired,
  // title: PropTypes.string.isRequired,
};
export default RulesGallery;
